<template>
  <div class="parking_box">
    <template v-if="showPage">
      <!-- 套餐类型 -->
      <package-select
        :parkingMess="parkingMess"
        :dayNightType="dayNightType"
        @packageChange="packageChange"
        :ParkFeeId="ParkFeeId"
        :ParkFeeSelectItem="ParkFeeSelectItem"
      ></package-select>
      <!-- 填写申请信息 -->
      <apply-message
        come="xuqian"
        :showApplyInput="maxEndDay-applyLastEndTime>0 && maxEndDay-curTime>0"
        :name="userName"
        @inputChange="inputChange"
        :applyData="applyData"
        :maxEndDay="maxEndDay"
        :parkingMess="parkingMess"
        :prkParkFeeBean="prkParkFeeBean"
      ></apply-message>
      <!-- 车牌号 如果月卡优惠的最大时间大于用户申请的时间,并且最大时间大于当前的时间-->
      <card-number
        v-if="maxEndDay-applyLastEndTime>0 && maxEndDay-curTime>0"
        @inputChange="inputChange"
        come="xuqian"
        :applyData="applyData"
        :xuqianCardList="cardList"
        :showUpLoadImg="false"
      ></card-number>
      <section class="footer_h"></section>
       <div class="agreeView" v-if="isShowAgree" >
          <div @click="changeAgree" v-if="!isAgree" class="agreeView_div"></div>
          <img  @click="changeAgree" v-else class="agreeView_icon" src="../../assets/images/icon_check_0.png" />
          <span @click="showPopup" class="agreeView_span1">请查阅并同意</span>
          <span @click="showPopup"  class="agreeView_span2">{{"《"+parkingMess.noticeTitle+"》"}}</span>
      </div>
      <common-footer text="立即申请" :canClick="canClick" @btnClick="btnClick"></common-footer>
    </template>
    <mt-popup v-model="isshowPopup" class="mint-popup">
        <div class="popupview">
            <span class="popupview-span1">{{parkingMess.noticeTitle}}</span>
            <textarea readonly class="popupview-span2" v-model="parkingMess.noticeContent"></textarea>
            <!-- <span class="popupview-span2" v->dsdsd  \n  sdsdsd</span> -->
            <span @click="hidePopup" class="popupview-span3">知道了</span>
        </div>
    </mt-popup>
  </div>
</template>

<script>
import PackageSelect from './components/packageSelect';
import ApplyMessage from './components/applyMessage';
import CardNumber from './components/cardNumber';
import CommonFooter from '../../components/footer';
import util from '../../utils/util';
import { approvalMixin } from '../../utils/approvalMixin';
import storage from '../../utils/storage';
import { loadParkHeaderById } from '../../utils/api';
import { mapState } from 'vuex';
import moment from 'moment'
export default {
  name: 'parking',
  props: {},
  mixins: [approvalMixin],
  components: {
    PackageSelect,
    ApplyMessage,
    CardNumber,
    CommonFooter
  },
  filters: {
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  data() {
    return {
      isAgree :false,
      isShowAgree :false,
      isshowPopup:false,
      approvalProcessTime:0,//发起流程次数
      startInstanceTime:0,//发起审批次数
      canClick:false,
      tips:false,
      applyMess:false,
      parkingMess:{},
      userName:'',
      applyData:{},
      cardList:[],//车牌数据
      showPage:false,
      applyUser:'',
      maxEndDay:9640880000000,
      startTime:'',
      endTime:'',
      ParkFeeId:'',
      ParkFeeSelectItem:'',
      prkParkFeeBean:{},
      feeTypeName:'',// 取值对应的是parkTypeName
      vipTypeCode:'',// 取值对应的是typeCode
      vipTypeName:'',// 取值对应的是typeName
      applyStartDay:'',
      applyEndDay:'',
      dayNightType:1,
      applyLastEndTime:'',//用户申请的最后一条数据的截止时间
      feeTypeId:'',
      curTime:''
    }
  },
  created() {
    // 获取停车场信息
    this.ParkFeeId =this.$route.query.ParkFeeId;
    this.feeTypeId = this.$route.query.feeTypeId;
    this.loadParkHeaderById()
    this.loadParkLot()
    this.curTime = new Date().valueOf()
  },
  mounted() {

  },
  activated() {
    if (storage.getS("ParkFeeSelectItem")) {
      this.ParkFeeSelectItem = JSON.parse(storage.getS("ParkFeeSelectItem"));
      this.prkParkFeeBean =this.ParkFeeSelectItem
      storage.removeS('ParkFeeSelectItem');
    }
  },
  methods: {
    canClickFun() {

    },
    showPopup(){
        this.isshowPopup=true;
    },
    hidePopup(){
        this.isshowPopup =false;
    },

    packageChange(item) {
      if (item) {
        this.dayNightType = item.dayNightType
        if(this.maxEndDay !=item.maxEndDay){
            this.canClick =false;
        }
        this.maxEndDay = item.maxEndDay
        this.ParkFeeId = item.id;
        this.feeTypeName = item.parkTypeName;
        this.vipTypeCode = item.typeCode;
        this.vipTypeName = item.typeName;
        this.prkParkFeeBean =item
      }
    },
    inputChange(val) {
      if (val.type == 'name') {
        this.userName = val.val;
      } else if (val.type == 'time') {
        console.log(JSON.stringify(val.val))
        this.applyStartDay = val.val.startTime
        this.applyEndDay = val.val.endTime
      } else if (val.type == 'card') {
        let cardList = val.data || [];
        this.cardList = cardList;
        let plateNo = []
        cardList.forEach(item => {
          plateNo.push(item.cardNumber)
        })
        this.plateNo = plateNo.join(",")
      }
      if (!this.userName || !this.applyStartDay || !this.applyEndDay ) {
        this.canClick = false
      } else {
        this.canClick = true
      }

      if(this.isShowAgree && this.canClick){
          if(!this.isAgree){
            this.canClick = false
          }
      }
    },
    changeAgree(){
      this.isAgree =!this.isAgree;
      if (!this.userName || !this.applyStartDay || !this.applyEndDay  ||!this.isAgree) {
        this.canClick = false
      } else {
        this.canClick = true
      }
    },
    // 获取车场数据
    loadParkHeaderById() {
      util.showLoading();
      let params = {
        id: this.$route.query.parkId,
        url: "/parking/rstParkHeader/loadParkHeaderById"
      }
      loadParkHeaderById(params).then(res => {
        util.hideLoading()
        console.log("this.ParkFeeSelectItem")
        console.log( JSON.stringify(res) )
        if(res.res.code === 10000 && res.body){
          this.parkingMess = res.body.data

          if(res.body.data.prkParkFeeBeanList && res.body.data.prkParkFeeBeanList.length > 0){
            let newL = res.body.data.prkParkFeeBeanList.filter(item=>{return item.parkType == 4})
            res.body.data.prkParkFeeBeanList.forEach(item=>{
              console.log("item.parkType 4  == " + item.parkType)
              if(item.parkType == 4 && item.id == this.feeTypeId){

                // this.maxEndDay = item.maxEndDay;//价格区间最大日期
                this.dayNightType = item.dayNightType
                this.maxEndDay = item.maxEndDay
                this.ParkFeeId = item.id;
                this.feeTypeName = item.parkTypeName;
                this.vipTypeCode = item.typeCode;
                this.vipTypeName = item.typeName;
                this.ParkFeeSelectItem =item;
                this.prkParkFeeBean =item;
                console.log("item.parkType ==4 item.id == this.feeTypeId")
                // console.log(this.ParkFeeSelectItem)
              }
            })
            if (newL.length == 0) {
              util.showModal('', '该项目停车场尚未配置停车月租优惠', false, '我知道了', () => {
                this.$router.go(-1)
              })
            }
          }
          var showAgree =this.parkingMess.enableMonthNotice;
          if(showAgree !=2){
              this.isShowAgree =true
          }else{
              this.isShowAgree =false;
          }
        } else {
          util.showToast(res.res.msg)
        }
      })
    },
    // 获取用户申请信息
    loadParkLot() {
      util.showLoading()
      let params = {
        userId: this.common.userId,
        phone: this.common.userInfo.account || this.common.userInfo.phone,
        parkHeaderId: this.$route.query.parkId,
        url: "/parking/rstParkLot/loadParkLot"
      }
      loadParkHeaderById(params).then(res => {
        util.hideLoading()
        console.log(res)
        if (res.res && res.res.code === 10000 && res.body && res.body.data) {
          this.applyData = res.body.data;
          this.dayNightType = this.applyData.dayNightType;
          this.userName = this.applyData.userName;
          let cardList = this.applyData.prkParkLotPlateBeans || [];
          let n = cardList.filter(item => { return item.applyStatus == 2 })
          this.cardList = n;
          // applyLastEndTime 用户申请的最后一条数据的截止时间
          let d = this.applyData.prkParkApplyLogBeans[this.applyData.prkParkApplyLogBeans.length - 1].applyEndDay.replace(/\./g, '/');
          this.applyLastEndTime = new Date(d).valueOf()
        }
        this.showPage = true;
      })
    },
    btnClick() {
      if (new Date(this.applyStartDay.replace(/-/g, "/") + ' 00:00:00').getTime() - new Date(this.applyEndDay.replace(/-/g, "/") + ' 23:59:59').getTime() > 0) {
        util.showToast('结束时间应该大于开始时间', 2000)
        return false;
      }
      let applyMinUnit = this.parkingMess.applyMinUnit;//最小起租单位（1天 2月）
      let applyMaxCount = this.parkingMess.applyMaxCount;//最大起租数
      let applyMinCount = this.parkingMess.applyMinCount;//最小起租数
      let applyMaxUnit = this.parkingMess.applyMaxUnit;//最大申请单位（1天 2月）
      let monthType = this.parkingMess.monthType;//1(整月模式 年月),2(非整月 年月日)
      if (monthType == 1) {
        let startD = this.applyStartDay.split("-");
        let endD = this.applyEndDay.split("-");
        if ((endD[0] - startD[0]) * 12 + Number(endD[1]) - Number(startD[1]) < applyMinCount - 1) {
          util.showToast(`最小起租${applyMinCount}个月`, 2000)
          return;
        }
      } else {
        // 最小起租单位为天
        if (applyMinUnit == 1) {
          // 结束时间-开始时间 小于 最小起租数
          if (Math.round((new Date(this.applyEndDay.replace(/-/g, "/") + ' 23:59:59').getTime() - new Date(this.applyStartDay.replace(/-/g, "/") + ' 00:00:00').getTime()) / (24 * 60 * 60 * 1000)) < applyMinCount) {
            util.showToast(`最小起租${applyMinCount}天`, 2000)
            return false;
          }
        } else {
          // 开始时间+n月后的时间-结束时间 大于 结束时间
          let startD = this.applyStartDay.split("-");
          let ys = parseInt((startD[1] - 0 + this.parkingMess.applyMinCount) / 12);
          let year = startD[0] + ys;
          let month = startD[1] - 0 + this.parkingMess.applyMinCount - ys * 12 >= 10 ? startD[1] - 0 + this.parkingMess.applyMinCount - ys * 12 : '0' + (startD[1] - 0 + this.parkingMess.applyMinCount - ys * 12)
          let day = Number(startD[2]) >= 10 ? startD[2] : '0' + startD[2]
          let newSjc = new Date(year + '/' + month + '/' + day + ' 00:00:00').getTime() - 24 * 60 * 60 * 1000
          if (newSjc > new Date(this.applyEndDay.replace(/-/g, ".") + ' 23:59:59').getTime()) {
            util.showToast(`最小起租${applyMinCount}月`, 2000)
            return false;
          }
        }
      }
      if (this.applyStartDay.split('-').length === 2) {
        this.applyStartDay = this.applyStartDay + "-01"
        let endt = new Date(this.applyEndDay.split('-')[0], this.applyEndDay.split('-')[1], 0);
        let { year, month, day } = util.formatTime(endt, 17);
        this.applyEndDay = util.formatTime(new Date(year + '/' + month + '/' + day + ' 23:59:59'), 9)
      }
      if (!this.ParkFeeId) {
        util.showToast("请选择优惠套餐")
        return false;
      }
      util.showLoading('提交中...')
     
      let month = moment(this.applyEndDay).add(1, 'day').diff(moment(this.applyStartDay), 'month')

      var applyCount =
        month +
        '月' +
        moment(this.applyEndDay)
          .add(1, 'day')
          .subtract(month, 'month')
          .diff(moment(this.applyStartDay), 'day') +
        '天（' +
        moment(this.applyEndDay).diff(moment(this.applyStartDay), 'day') +
        '天）'
      var applyDay =''
      // let monthType = this.parkingMess.monthType;//1(整月模式 年月),2(非整月 年月日)
      if(monthType ==1){
        applyDay =month
      }else{
        applyDay = applyCount
      }
      this.canClick = false
      let params = {
        "id": this.applyData.id,
        "platform": "RST",
        "userId": this.common.userId,
        "userName": this.userName,
        "companyName": "",
        "companyId": "",
        "subProjectId": this.common.marketInfo.id,//项目id
        "phone": this.common.userInfo.account || this.common.userInfo.phone,
        "numberType": 2,//申请类型 2个人月租 3临停优惠
        "parkHeaderId": this.parkingMess.id,//车场id
        "plateNo": this.applyData.plateNo,//车牌
        "applyStartDay": this.applyStartDay.replace(/-/g, ".") + ' 00:00:00',
        "applyEndDay": this.applyEndDay.replace(/-/g, ".") + ' 23:59:59',
        applyDay:applyDay,
        "dayNightType": this.dayNightType,// 1、全天；2、白天；3夜晚
        feeTypeId: this.ParkFeeId,
        feeTypeName: this.feeTypeName,
        vipTypeCode: this.vipTypeCode,
        vipTypeName: this.vipTypeName,
        "url": "/parking/rstParkLot/applayNextParkLot"
      }
      if (this.common.userTenantInfo.id) {
          params.companyName = this.common.userTenantInfo.company,
          params.companyId = this.common.userTenantInfo.companyId
      }
      loadParkHeaderById(params).then(res => {
        console.log(res)
        if (res.res.code === 10000 && res.body) {
          // 判断是否续签需要审核 approval 1需要,2不需要
          if (this.$route.query.approval == 2) {
            util.showToast('申请成功')
            storage.setS("isNeedFresh", true)
            this.$router.go(-1)
            return;
          }
          // 申请待办
          if(res.body.data.bizFlag ){
            this.approvalProcess(res.body.data,
              () => {
                util.hideLoading()
                storage.setS('isNeedFresh', true)
                this.$router.go(-1)
              },
              () => {
                this.canClick = true
                storage.setS('isNeedFresh', true)
                util.hideLoading()
                this.$router.go(-1)
                util.showToast('提交失败')
              })
          }else{
             util.hideLoading()
             storage.setS('isNeedFresh', true)
             this.$router.go(-1)
          }
        } else {
          this.canClick = true
          util.hideLoading()
          util.showToast(res.res.msg)
        }
      })
    },
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.parking_box {
  background: #eee;
}
.footer_h {
  height: 208px;
}
.hb_height {
  height: 76px;
}
.hb_tips {
  position: fixed;
  bottom: 108px;
  left: 0;
  right: 0;
  .flex();
  justify-content: center;
  align-items: center;
  height: 76px;
  background: rgba(254, 238, 223, 1);
  .hint_icon {
    width: 28px;
    height: 28px;
    margin-right: 14px;
  }
  p {
    font-size: 26px;
    color: rgba(253, 152, 56, 1);
  }
  .close_icon {
    position: absolute;
    top: 16px;
    right: 10px;
    width: 44px;
    height: 44px;
  }
}
.agreeView{
  position: fixed;
  bottom:108px;left:0;right:0;
  // box-shadow:0px -1px 14px 0px rgba(0,0,0,0.09);
  z-index:333;
  background:#fff;
  height:88px;
  width:100%;
   display: flex;
  flex-direction: row;
  align-items: center;
}
.agreeView_div{
  //  display: flex;
   margin-left: 28px;
   width: 32px;
   height: 32px;
   border-radius: 100%;
   border: 2px solid #eaeaea;
   background-color: white;
}
.agreeView_icon{
   margin-left: 28px;
   width: 36px;
   height: 36px;
}
.agreeView_span1{
  margin-left: 14px;
  height:36px;
  font-size:26px;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:36px;
}
.agreeView_span2{
  margin-left: 4px;
  height:36px;
  font-size:26px;
  font-weight:400;
  color:#1740DA;
  line-height:36px;
}
.popupview{
  width:600px;
  display: flex;
  flex-direction: column;
  background:rgba(255,255,255,1);
  border-radius:8px;
}
.popupview-span1{
  margin-left: 40px;
  margin-top: 40px;
  width: 520px;
  font-size:40px;
  font-weight:500;
  color:rgba(51,51,51,1);
  line-height:56px;
}
.popupview-span2{
  margin-left: 40px;
  margin-top: 28px;
  width: 520px;
  height: 450px;
  font-size:28px;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:40px;
}
.popupview-span3{
  margin-left: 40px;
  margin-top: 62px;
  margin-bottom: 40px;
  width:520px;
  height:88px;
  background:rgba(23,64,218,1);
  border-radius:4px;
  text-align: center;
  font-size:34px;
  font-weight:400;
  color:rgba(255,255,255,1);
  line-height:88px;

}
</style>
